import { render, staticRenderFns } from "./Groupusers.vue?vue&type=template&id=2d8c3632&scoped=true&"
import script from "./Groupusers.vue?vue&type=script&lang=js&"
export * from "./Groupusers.vue?vue&type=script&lang=js&"
import style0 from "./Groupusers.vue?vue&type=style&index=0&id=2d8c3632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c3632",
  null
  
)

export default component.exports